import styled from 'styled-components';

import {RowStyles} from './../../../../../../stories/core-components/Layouts/Layouts';

export const BusOutline = styled.div`
  width: 385px;
  height: 160px;
  border: 1px solid #e1e1e1;
  border-radius: 0.6rem;
  display: flex;
  flex-direction: row;
  margin: 1rem 0;
  .header {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 30px;
    background: #eff3f8;
    position: relative;
    span {
      transform: rotate(-90deg);
      font-size: 12px;
      color: #647a97;
      position: relative;
      top: 45%;
      right: 3px;
    }
  }
  .busContent {
    position: relative;
    background: white;
    margin: 1.2rem 1.7rem;
    flex-direction: row;
    display: flex;
    flex-wrap: wrap;
  }
  .iconWrap {
    position: absolute;
    top: 2.5rem;
    left: 0.9rem;
    transform: scale(0.8);
  }
`;
